// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Dropdown from "./Dropdown.js";
import * as Buhta_cabinet__Field from "./Field.js";
import * as Buhta_components__CountryIcon from "../../../../../packages/components/src/atoms/CountryIcon.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_models__Locale from "../../../../../packages/models/Locale.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Caml_string from "melange.js/caml_string.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(country) {
  return function (onCountrySelect) {
    const match = React.useState(function () {
          return false;
        });
    const setIsDropdownShown = match[1];
    const activator = function (param) {
      const Key = Buhta_models__Locale.toCountryString(country);
      return JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(Buhta_components__CountryIcon.make, {
                          country: country
                        }),
                    JsxRuntime.jsx("img", {
                          className: "ml-1 w-4 h-4 translate-y-[1px]",
                          src: StaticAsset.src("/static/icons/arrow-down-black.svg")
                        }),
                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                          className: "ml-2",
                          children: Buhta_models__Locale.getPhonePrefix(country)
                        })
                  ],
                  className: "h-full pt-0 flex items-center animate-fadeIn"
                }, Key);
    };
    return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
                innerClassName: "!top-11 !left-11/20",
                align: "BottomCenter",
                activator: activator,
                background: "bg-white",
                isDropdownShown: match[0],
                setIsDropdownShown: setIsDropdownShown,
                children: JsxRuntime.jsx("div", {
                      children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex({
                                hd: /* COUNTRY_KAZ */1,
                                tl: {
                                  hd: /* COUNTRY_UZB */3,
                                  tl: {
                                    hd: /* COUNTRY_KGZ */2,
                                    tl: /* [] */0
                                  }
                                }
                              }, (function (index, code) {
                                  const Key = "country-" + String(index);
                                  return JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_components__CountryIcon.make, {
                                                      country: code
                                                    }),
                                                JsxRuntime.jsx(Buhta_components__Text.P.make, {
                                                      children: Buhta_models__Locale.getPhonePrefix(code)
                                                    })
                                              ],
                                              className: "flex items-center space-x-2 px-4 py-1.5 hover:bg-gray-light cursor-pointer",
                                              onClick: (function (param) {
                                                  Curry._1(onCountrySelect, code);
                                                  Curry._1(setIsDropdownShown, (function (param) {
                                                          return false;
                                                        }));
                                                })
                                            }, Key);
                                }))),
                      className: "py-2 flex flex-col"
                    })
              });
  };
}

function PhoneField$CountryCodeDropdown(Props) {
  return make(Props.country)(Props.onCountrySelect);
}

const CountryCodeDropdown = {
  make: PhoneField$CountryCodeDropdown
};

const _map = {"s":"s","m":"m","l":"l"};

function sizeToJs(param) {
  return param;
}

function sizeFromJs(param) {
  return _map[param];
}

function make$1(value) {
  return function (onChange) {
    return function (requiredOpt) {
      const required = requiredOpt !== undefined ? requiredOpt : false;
      return function (disabledOpt) {
        const disabled = disabledOpt !== undefined ? disabledOpt : false;
        return function (sizeOpt) {
          return function (className) {
            return function (labelOpt) {
              const label = labelOpt !== undefined ? labelOpt : "";
              const match = React.useState(function () {
                    if (value.length > 4 && !(Caml_string.get(value, 0) === /* '+' */43 && Caml_string.get(value, 1) === /* '7' */55)) {
                      if (Caml_string.get(value, 0) === /* '+' */43 && Caml_string.get(value, 1) === /* '9' */57 && Caml_string.get(value, 2) === /* '9' */57 && Caml_string.get(value, 3) === /* '8' */56) {
                        return /* COUNTRY_UZB */3;
                      } else if (Caml_string.get(value, 0) === /* '+' */43 && Caml_string.get(value, 1) === /* '9' */57 && Caml_string.get(value, 2) === /* '9' */57 && Caml_string.get(value, 3) === /* '6' */54) {
                        return /* COUNTRY_KGZ */2;
                      } else {
                        return /* COUNTRY_KAZ */1;
                      }
                    } else {
                      return /* COUNTRY_KAZ */1;
                    }
                  });
              const setCountry = match[1];
              const country = match[0];
              const minLength = Buhta_models__Locale.getPhoneSuffixLength(country);
              const maxLength = Buhta_models__Locale.getPhoneSuffixLength(country);
              const onChange$1 = function (text, country) {
                let country$1 = country;
                if (text.length > 4) {
                  if (Caml_string.get(text, 0) === /* '+' */43 && Caml_string.get(text, 1) === /* '7' */55) {
                    Curry._1(setCountry, (function (param) {
                            return /* COUNTRY_KAZ */1;
                          }));
                    country$1 = /* COUNTRY_KAZ */1;
                  } else if (Caml_string.get(text, 0) === /* '+' */43 && Caml_string.get(text, 1) === /* '9' */57 && Caml_string.get(text, 2) === /* '9' */57 && Caml_string.get(text, 3) === /* '8' */56) {
                    Curry._1(setCountry, (function (param) {
                            return /* COUNTRY_UZB */3;
                          }));
                    country$1 = /* COUNTRY_UZB */3;
                  } else if (Caml_string.get(text, 0) === /* '+' */43 && Caml_string.get(text, 1) === /* '9' */57 && Caml_string.get(text, 2) === /* '9' */57 && Caml_string.get(text, 3) === /* '6' */54) {
                    Curry._1(setCountry, (function (param) {
                            return /* COUNTRY_KGZ */2;
                          }));
                    country$1 = /* COUNTRY_KGZ */2;
                  }
                  
                }
                const numbersExtracted = text.replace(/\D/g, "");
                const suffixLength = Buhta_models__Locale.getPhoneSuffixLength(country$1);
                const prefix = Buhta_models__Locale.getPhonePrefix(country$1);
                const lastNumbers = numbersExtracted.substring(numbersExtracted.length - suffixLength | 0, (suffixLength + Buhta_models__Locale.getPhonePrefixLength(country$1) | 0) - 1 | 0);
                const formattedNumber = lastNumbers.length <= 0 ? "" : (
                    lastNumbers.length < suffixLength ? prefix + lastNumbers : prefix + lastNumbers
                  );
                Curry._1(onChange, formattedNumber);
              };
              const match$1 = React.useState(function () {
                    return false;
                  });
              const setIsFocused = match$1[1];
              const isFocused = match$1[0];
              const inputRef = React.useRef(null);
              return JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx(PhoneField$CountryCodeDropdown, {
                                        country: country,
                                        onCountrySelect: (function (country) {
                                            Curry._1(setCountry, (function (param) {
                                                    return country;
                                                  }));
                                            const __x = inputRef.current;
                                            Belt__Belt_Option.map((__x == null) ? undefined : Caml_option.some(__x), (function (el) {
                                                    return el.focus();
                                                  }));
                                            onChange$1("", country);
                                          })
                                      }),
                                  className: "absolute z-2 h-full ml-4 flex items-center"
                                }),
                            label !== "" ? JsxRuntime.jsx("label", {
                                    children: label,
                                    className: Cn.$plus("absolute -top-[4px] ml-1 left-[9px] px-2 text-asphalt transition-transform ease-in-out duration-250 bg-white z-10 cursor-text", isFocused || value !== "" ? "text-preheader translate-y-0" : Cn.$plus("text-sm translate-y-[19px]", country !== 1 ? "translate-x-[93px]" : "translate-x-[71px]")),
                                    onClick: (function (param) {
                                        Curry._1(setIsFocused, (function (param) {
                                                return true;
                                              }));
                                      })
                                  }) : null,
                            JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                  type_: "text",
                                  disabled: disabled,
                                  size: "m",
                                  required: required,
                                  onChange: (function (value) {
                                      onChange$1(value, country);
                                    }),
                                  textPadding: country !== 1 ? "pl-25" : "pl-21",
                                  inputRef: inputRef,
                                  minLength: minLength,
                                  maxLength: maxLength,
                                  onFocusChanged: (function (value) {
                                      Curry._1(setIsFocused, (function (param) {
                                              return value;
                                            }));
                                    }),
                                  value: value.replace(new RegExp("^\\" + Buhta_models__Locale.getPhonePrefix(country)), ""),
                                  isFocused: isFocused
                                })
                          ],
                          className: Cn.fromList({
                                hd: "relative",
                                tl: {
                                  hd: Cn.take(className),
                                  tl: /* [] */0
                                }
                              })
                        });
            };
          };
        };
      };
    };
  };
}

function PhoneField(Props) {
  return Curry._5(make$1(Props.value)(Props.onChange), Props.required, Props.disabled, Props.size, Props.className, Props.label);
}

const make$2 = PhoneField;

export {
  CountryCodeDropdown ,
  sizeToJs ,
  sizeFromJs ,
  make$2 as make,
}
/* Buhta_cabinet__Dropdown Not a pure module */
